// Canonical priority levels for work orders and follow-ups.
// Values are stored in the DB; labels are for display.
// Ordering: lower `order` = more urgent (shown first).

export const PRIORITY_OPTIONS = [
  { value: 'p0', label: 'P0 - High', order: 0, badgeClass: 'bg-red-500' },
  { value: 'p1', label: 'P1 - Medium', order: 1, badgeClass: 'bg-orange-500' },
  { value: 'p2', label: 'P2 - Low', order: 2, badgeClass: 'bg-yellow-500' },
  { value: 'p3', label: 'P3 - Not Urgent', order: 3, badgeClass: 'bg-slate-400' },
];

// Backward-compat map from legacy priority strings (in case any stale
// documents slip past the migration script).
const LEGACY_MAP = {
  high: 'p0',
  medium: 'p1',
  low: 'p2',
};

export const normalizePriority = (raw) => {
  if (!raw) return null;
  const key = String(raw).toLowerCase();
  if (LEGACY_MAP[key]) return LEGACY_MAP[key];
  return key;
};

const OPTION_BY_VALUE = PRIORITY_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt;
  return acc;
}, {});

export const getPriorityLabel = (raw) => {
  const v = normalizePriority(raw);
  return OPTION_BY_VALUE[v]?.label || raw || '';
};

export const getPriorityBadgeClass = (raw) => {
  const v = normalizePriority(raw);
  return OPTION_BY_VALUE[v]?.badgeClass || 'bg-gray-500';
};

// Sort compare fn: unset priorities go last.
export const comparePriority = (a, b) => {
  const av = OPTION_BY_VALUE[normalizePriority(a)]?.order ?? 99;
  const bv = OPTION_BY_VALUE[normalizePriority(b)]?.order ?? 99;
  return av - bv;
};
